import { ReservationDish } from './reservation-dish';

export class Reservation {
    id: number;
    externalRef: string;
    orderdate: Date;
    isPaid: boolean;
    isCollaborator: boolean;
    dishes: ReservationDish[];
    state: number;
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/models/reservation.ts